/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createGame } from "../graphql/mutations";
const client = generateClient();
export default function GameCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    providerId: "",
    title: "",
    year: "",
    developer: "",
    description: "",
    howToPlay: "",
    poster: "",
    contentType: "",
  };
  const [providerId, setProviderId] = React.useState(initialValues.providerId);
  const [title, setTitle] = React.useState(initialValues.title);
  const [year, setYear] = React.useState(initialValues.year);
  const [developer, setDeveloper] = React.useState(initialValues.developer);
  const [description, setDescription] = React.useState(
    initialValues.description
  );
  const [howToPlay, setHowToPlay] = React.useState(initialValues.howToPlay);
  const [poster, setPoster] = React.useState(initialValues.poster);
  const [contentType, setContentType] = React.useState(
    initialValues.contentType
  );
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setProviderId(initialValues.providerId);
    setTitle(initialValues.title);
    setYear(initialValues.year);
    setDeveloper(initialValues.developer);
    setDescription(initialValues.description);
    setHowToPlay(initialValues.howToPlay);
    setPoster(initialValues.poster);
    setContentType(initialValues.contentType);
    setErrors({});
  };
  const validations = {
    providerId: [{ type: "Required" }],
    title: [],
    year: [],
    developer: [],
    description: [],
    howToPlay: [],
    poster: [],
    contentType: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          providerId,
          title,
          year,
          developer,
          description,
          howToPlay,
          poster,
          contentType,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createGame.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "GameCreateForm")}
      {...rest}
    >
      <TextField
        label="Provider id"
        isRequired={true}
        isReadOnly={false}
        value={providerId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId: value,
              title,
              year,
              developer,
              description,
              howToPlay,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.providerId ?? value;
          }
          if (errors.providerId?.hasError) {
            runValidationTasks("providerId", value);
          }
          setProviderId(value);
        }}
        onBlur={() => runValidationTasks("providerId", providerId)}
        errorMessage={errors.providerId?.errorMessage}
        hasError={errors.providerId?.hasError}
        {...getOverrideProps(overrides, "providerId")}
      ></TextField>
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title: value,
              year,
              developer,
              description,
              howToPlay,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Year"
        isRequired={false}
        isReadOnly={false}
        value={year}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year: value,
              developer,
              description,
              howToPlay,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.year ?? value;
          }
          if (errors.year?.hasError) {
            runValidationTasks("year", value);
          }
          setYear(value);
        }}
        onBlur={() => runValidationTasks("year", year)}
        errorMessage={errors.year?.errorMessage}
        hasError={errors.year?.hasError}
        {...getOverrideProps(overrides, "year")}
      ></TextField>
      <TextField
        label="Developer"
        isRequired={false}
        isReadOnly={false}
        value={developer}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year,
              developer: value,
              description,
              howToPlay,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.developer ?? value;
          }
          if (errors.developer?.hasError) {
            runValidationTasks("developer", value);
          }
          setDeveloper(value);
        }}
        onBlur={() => runValidationTasks("developer", developer)}
        errorMessage={errors.developer?.errorMessage}
        hasError={errors.developer?.hasError}
        {...getOverrideProps(overrides, "developer")}
      ></TextField>
      <TextField
        label="Description"
        isRequired={false}
        isReadOnly={false}
        value={description}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year,
              developer,
              description: value,
              howToPlay,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.description ?? value;
          }
          if (errors.description?.hasError) {
            runValidationTasks("description", value);
          }
          setDescription(value);
        }}
        onBlur={() => runValidationTasks("description", description)}
        errorMessage={errors.description?.errorMessage}
        hasError={errors.description?.hasError}
        {...getOverrideProps(overrides, "description")}
      ></TextField>
      <TextField
        label="How to play"
        isRequired={false}
        isReadOnly={false}
        value={howToPlay}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year,
              developer,
              description,
              howToPlay: value,
              poster,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.howToPlay ?? value;
          }
          if (errors.howToPlay?.hasError) {
            runValidationTasks("howToPlay", value);
          }
          setHowToPlay(value);
        }}
        onBlur={() => runValidationTasks("howToPlay", howToPlay)}
        errorMessage={errors.howToPlay?.errorMessage}
        hasError={errors.howToPlay?.hasError}
        {...getOverrideProps(overrides, "howToPlay")}
      ></TextField>
      <TextField
        label="Poster"
        isRequired={false}
        isReadOnly={false}
        value={poster}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year,
              developer,
              description,
              howToPlay,
              poster: value,
              contentType,
            };
            const result = onChange(modelFields);
            value = result?.poster ?? value;
          }
          if (errors.poster?.hasError) {
            runValidationTasks("poster", value);
          }
          setPoster(value);
        }}
        onBlur={() => runValidationTasks("poster", poster)}
        errorMessage={errors.poster?.errorMessage}
        hasError={errors.poster?.hasError}
        {...getOverrideProps(overrides, "poster")}
      ></TextField>
      <TextField
        label="Content type"
        isRequired={false}
        isReadOnly={false}
        value={contentType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              providerId,
              title,
              year,
              developer,
              description,
              howToPlay,
              poster,
              contentType: value,
            };
            const result = onChange(modelFields);
            value = result?.contentType ?? value;
          }
          if (errors.contentType?.hasError) {
            runValidationTasks("contentType", value);
          }
          setContentType(value);
        }}
        onBlur={() => runValidationTasks("contentType", contentType)}
        errorMessage={errors.contentType?.errorMessage}
        hasError={errors.contentType?.hasError}
        {...getOverrideProps(overrides, "contentType")}
      ></TextField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
